/* global angular */
( function () {
	'use strict';

	function FormulaParser () {
		return {
			'templateUrl'      : '/templates/components/math/interface/formula-parser/formula-parser.html',
			'restrict'         : 'E',
			'replace'          : true,
			'controller'       : 'FormulaParserCtrl',
			'controllerAs'     : 'vm',
			'bindToController' : true,
			'scope'            : {
				'indicators' : '=',
				'groups'     : '=',
				'formula'    : '=',
				'prefix'     : '='
			}
		};
	}

	angular
		.module( 'app.components' )
		.directive( 'formulaParser', FormulaParser );
} )( );
